import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApicallsService } from '../services/apicalls.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';
import { AlertService } from '../services/alert.service';
import { first } from 'rxjs/operators';

import swal from 'sweetalert2';
import toastr from 'toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-Register',
  templateUrl: './Register.component.html',
  styleUrls: ['./Register.component.scss']
})
export class RegisterComponent implements OnInit {

  year: any;
  formRegister: FormGroup;
  pasError = false;
  levelPass = 0;
  formForgot: FormGroup;
  formNewPassword: FormGroup;
  loading = false;
  submitted = false;
  showForgot = false;
  newUser = false;
  idUser: any;
  returnUrl: string;
  showPassword = false;

  constructor(private formBuilder: FormBuilder,
              private route: ActivatedRoute,
              private api: ApicallsService,
              private router: Router,
              private spinner: NgxSpinnerService,
              private authenticationService: AuthenticationService,
              private alertService: AlertService) {

              if (this.authenticationService.currentUserValue) {
                  this.router.navigate(['/dashboard']);
              }
  }

  ngOnInit() {
    this.year = new Date().getFullYear();
    this.formRegister = this.formBuilder.group({
        nombre_empresa: ['', Validators.required],
        email: ['', [ Validators.required, Validators.email]],
        password: ['', Validators.required],
        codigo: [''],
        accept: ['']
    });

    this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/dashboard';
  }

  visiblePassword(value) {
      this.showPassword = value;
  }

  forgot() {
    this.showForgot = true;
  }

  Register(formValue: any) {
    if (this.levelPass < 3) {
      swal.fire('Contraseña', 'La contraseña debe tener 1 letra mayúscula, 1 número y una longitud mínima de 8', 'error');
    } else {
      if (formValue.accept !== true) {
        swal.fire('Registro', 'Debes leer y aceptar nuestra política de privacidad', 'error');
        return;
      }
      this.spinner.show();
      this.api.newUserLite(formValue).subscribe((data: any)  => {
        this.spinner.hide();
        if (data.error && +data.error === 1) {
          swal.fire('Registro', data.message, 'error');
        } else {
          this.authenticationService.login( formValue.email , formValue.password ).pipe(first()).subscribe( () => {
              this.router.navigate(['/dashboard']);
          }, error => {
              swal.fire('Registro', 'Ya existe un usuario con ese email', 'error');
          });
        }
      }, error => {
        this.spinner.hide();
        swal.fire('Nuevo Usuario',
                  'Ocurrió un error al registrar el usuario, vuelva a intentarlo. Si persiste pongase en contacto ' +
                  'con desarrollo@unblockthecity.com y atenderemos su problema.',
                  'error');
      }
    );
    }
  }

  onInputPass(value) {
    let cont = 0;
    if (value.length === 0) {
        this.levelPass = 0;
        return;
    }

    if (value.length > 7) {
        cont ++;
    }

    const matches = value.match(/\d+/g);
    if (matches != null) {
        cont ++;
    }

    if (/[A-Z]/.test(value)) {
        cont ++;
    }

    if (cont === 0) {
        cont++;
    }
    this.levelPass = cont;
}

}
